import { render, staticRenderFns } from "./Fishing.vue?vue&type=template&id=3d1d6e1a&scoped=true"
import script from "./Fishing.vue?vue&type=script&lang=js"
export * from "./Fishing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1d6e1a",
  null
  
)

export default component.exports